import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { getAccessLevelDescription } from "@components/access-level/access-level-utils";
import { Box } from "@mui-wrapper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** Tooltip for access level component */
export function AccessLevelTooltip(t0) {
  const $ = _c(16);
  const {
    type
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box component="div" sx={{
      mb: "20px"
    }}>There are two types of access levels:</Box>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mb: "20px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== type) {
    t3 = getAccessLevelDescription(type, "private");
    $[2] = type;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${FaroCoreApiUtils.Project.AccessLevelDisplayNames.private} - ${t3}`;
  let t5;
  if ($[4] !== t4) {
    t5 = <Box component="div" sx={t2}>{t4}</Box>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== type) {
    t6 = getAccessLevelDescription(type, "unlisted");
    $[6] = type;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `${FaroCoreApiUtils.Project.AccessLevelDisplayNames.unlisted} - ${t6}`;
  let t8;
  if ($[8] !== t7) {
    t8 = <Box component="div">{t7}</Box>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <Box component="div">{t1}{t5}{t8}</Box>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "text.secondary",
      fontWeight: "normal",
      width: "fit-content",
      fontSize: "11px"
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <LabelWithHelp title="Access Level" help={t9} sx={t10} />;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}